/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CostExcludingTaxesResource } from './';
import {
    CostExcludingTaxesResourceFromJSON,
    CostExcludingTaxesResourceFromJSONTyped,
    CostExcludingTaxesResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkforceProjectsSummaryResource
 */
export interface WorkforceProjectsSummaryResource {
    /**
     * 
     * @type {number}
     * @memberof WorkforceProjectsSummaryResource
     */
    totalProjectsCount: number;
    /**
     * 
     * @type {number}
     * @memberof WorkforceProjectsSummaryResource
     */
    totalDaysWorked: number;
    /**
     * 
     * @type {Array<CostExcludingTaxesResource>}
     * @memberof WorkforceProjectsSummaryResource
     */
    totalCostExcludingTaxesList: Array<CostExcludingTaxesResource>;
}

/**
 * Check if a given object implements the WorkforceProjectsSummaryResource interface.
 */
export function instanceOfWorkforceProjectsSummaryResource(value: object): value is WorkforceProjectsSummaryResource {
    if (!('totalProjectsCount' in value) || value['totalProjectsCount'] === undefined) return false;
    if (!('totalDaysWorked' in value) || value['totalDaysWorked'] === undefined) return false;
    if (!('totalCostExcludingTaxesList' in value) || value['totalCostExcludingTaxesList'] === undefined) return false;
    return true;
}

export function WorkforceProjectsSummaryResourceFromJSON(json: any): WorkforceProjectsSummaryResource {
    return WorkforceProjectsSummaryResourceFromJSONTyped(json, false);
}

export function WorkforceProjectsSummaryResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkforceProjectsSummaryResource {
    if (json == null) {
        return json;
    }
    return {
        
        'totalProjectsCount': json['totalProjectsCount'],
        'totalDaysWorked': json['totalDaysWorked'],
        'totalCostExcludingTaxesList': ((json['totalCostExcludingTaxesList'] as Array<any>).map(CostExcludingTaxesResourceFromJSON)),
    };
}

export function WorkforceProjectsSummaryResourceToJSON(value?: WorkforceProjectsSummaryResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'totalProjectsCount': value['totalProjectsCount'],
        'totalDaysWorked': value['totalDaysWorked'],
        'totalCostExcludingTaxesList': ((value['totalCostExcludingTaxesList'] as Array<any>).map((v) => CostExcludingTaxesResourceToJSON(v))),
    };
}

